import AppConfig from '../appConfig';

const PREVIEW_HOST = /-pr(\d+)\.preview\./;

const previewNumberFromHost = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const match = window.location.hostname.match(PREVIEW_HOST);
    return match ? match[1] : null;
};

/**
 * Mixpanel super properties saying which environment an event came from. The
 * map has no build-time PR variable, so the PR number comes off the host.
 *
 * @returns {Object} environment, plus prNumber on a PR preview host
 */
export default function resolveAnalyticsEnvironment() {
    const prNumber = previewNumberFromHost();
    if (prNumber) {
        return { environment: 'preview', prNumber };
    }

    return { environment: AppConfig.constants.environment };
}
